import Cursor from "@/components/shared/icons/Cursor";

export { Cursor };
